import { render, staticRenderFns } from "./supplier-form-dialog.app.vue?vue&type=template&id=1b899442&"
import script from "./supplier-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./supplier-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports